import React from 'react'
import { observer } from 'mobx-react-lite'
import { Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { IntegrationSyncDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSyncDropdown/IntegrationSyncDropdown'
import { type IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { type IKeapSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/types'
import {
  getContactCreation,
  getPropertySync,
} from 'pages/settings/pages/integrations/pages/integrationSettings/lib'
import styles from './styles.module.scss'

type IIntegrationKeapSettingsSyncProps = {
  store: IntegrationSettingsSyncStore<IKeapSettingsDict>
}

export const IntegrationKeapSettingsSync: React.FC<IIntegrationKeapSettingsSyncProps> = observer(
  ({ store }) => {
    const {
      isTwoWaySync,
      setSyncType1_0,
      syncType,
      setCheckbox1_0,
      getCheckbox,
      selectItems,
      integrationName,
    } = store

    const CHECKBOXES = [
      getPropertySync('sync_save', integrationName),
      getContactCreation('sync_update', integrationName),
    ]

    return (
      <div className={styles.root}>
        <IntegrationSyncDropdown
          integrationIcon={'logoFfKeapCompany1'}
          iconHeight={90}
          isTwoWaySync={isTwoWaySync}
          syncType={syncType}
          setSyncType={setSyncType1_0}
          selectItems={selectItems}
        />
        {isTwoWaySync &&
          CHECKBOXES.map(({ field, title, label }) => (
            <TitledRow
              key={field}
              title={title}
              label={label}
              verticalAlign={'start'}
              className={styles.titledRow}
            >
              <Switch size='middle' value={getCheckbox(field)} onChange={setCheckbox1_0(field)} />
            </TitledRow>
          ))}
      </div>
    )
  }
)
